import { OptionType } from 'components';

export enum RepriseOptions {
    Non = 'NRP',
    Complet = 'RPI',
    PartielMedical = 'MMI',
    PartielPerso = 'TPI',
    PartielTherapeutique = '5', // TODO :: ????
}

export const repriseOptions: OptionType[] = [
    { value: RepriseOptions.Non, label: 'Non' },
    { value: RepriseOptions.Complet, label: 'A temps complet' },
    { value: RepriseOptions.PartielMedical, label: 'A temps partiel pour motif médical (avec accord de la CPAM)' },
    { value: RepriseOptions.PartielPerso, label: 'A temps partiel pour raisons personnelles' },
    { value: RepriseOptions.PartielTherapeutique, label: 'A temps partiel pour motif thérapeutique' },
];
/**
 * Filters the reprise options based on the provided keys (corresponding repriseOptions property in AT  scenario).
 *
 * @param {RepriseOptions[]} keys - An array of RepriseOptions keys to filter the options.
 */

export const filterRepriseOptions = (keys: string[]): OptionType<RepriseOptions>[] => {
    if (!keys) return [];
    return repriseOptions.filter((option): option is OptionType<RepriseOptions> => keys.includes(option.value as RepriseOptions));
}; // Reprise options for different cases
export const repriseOptionCas1: RepriseOptions[] = [RepriseOptions.Non, RepriseOptions.Complet, RepriseOptions.PartielTherapeutique];
export const repriseOptionCas2: RepriseOptions[] = [RepriseOptions.Non, RepriseOptions.Complet, RepriseOptions.PartielMedical, RepriseOptions.PartielPerso];
